import { combineReducers } from 'redux';
import categoryReducer from './category/categoryReducer';


const megaReducers = combineReducers({
	category: categoryReducer
});
export default megaReducers;
